'use client'

import { ToastContainer, TypeOptions  } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import IconNotInfo from '@/assets/img/Icon_Info.svg'
import IconNotSuccess from '@/assets/img/Icon_Ok.svg'
import IconNotError from '@/assets/img/Icon_Error_Remove-Categorie.svg'
import IconNotWarn from '@/assets/img/Icon_Tips.svg'
import IconClose from '@/assets/img/Icon_Cross.svg'
import { ComponentType, SVGProps } from 'react'

const iconMap: Record<TypeOptions, ComponentType<SVGProps<SVGSVGElement>>> = {
  info: IconNotInfo,
  success: IconNotSuccess,
  error: IconNotError,
  warning: IconNotWarn,
  default: IconNotInfo,
}

export default function NotificationRoot () {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      rtl={false}
      limit={3}
      closeButton={({ closeToast }) => (
        <button onClick={closeToast} className="Toastify__close-button">
          <IconClose />
        </button>
      )}
      icon={({ type }) => {
        const Icon = iconMap[type ?? 'default']
        return <Icon />
      }}
    />
  )
}